import { useEffect, useRef } from "react"
import { WBComponent } from "./WBComponents/WBComponent"
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";





//USED to reserver spaces where an element can be dragged and dropped to
export default function DropTarget({id,componentType,componentDef}:{id:string,componentType:string,componentDef:WBComponent}){


    const dropRef = useRef<HTMLDivElement>(null);

    const isSection = componentType == wBComponentTypeNames.section||componentType == wBComponentTypeNames.footer || componentType == wBComponentTypeNames.navigationBar;



    useEffect(()=>{

        const borderRange = 6;
        const moveAmount =6;
        if(dropRef.current){
            let parent = dropRef.current.closest(".hierarchy") as HTMLElement;

            if(parent){

                let pBounds = parent.getBoundingClientRect();
                let dBounds = dropRef.current.getBoundingClientRect();
                let moveY = 0;
                let moveX = 0;
                if(dBounds.left < pBounds.left + borderRange){
                   moveX = moveAmount;
                }
                 else if(dBounds.right > pBounds.right - borderRange){
                   moveX = -moveAmount;
                }
                if(dBounds.top < pBounds.top + borderRange){

                    moveY = moveAmount;
                }
                if(dBounds.bottom > pBounds.bottom - borderRange){
                    moveY = -moveAmount;
                }



                if(moveY!=0||moveX!=0){
                    dropRef.current.style.transform = "translate("+moveX+"px,"+moveY+"px)";

                }


            }


        }
    })
    /*BEGIN GRID LOGIC*/
    if(componentType== wBComponentTypeNames.grid)
        return null;
    /*END GRID LOGIC*/

    const domProps={wbcomponent:componentType}

    let classAdd = "";
    if(isSection)
        classAdd = "vertical";
    else if(componentType == wBComponentTypeNames.pageRoot)
        classAdd = "horizontal";

    return(

        <div  className={"drop-target "+(classAdd)}{...domProps} id={id} ref={dropRef}></div>
    )
}